import { MenuButtonProps, MenuListProps, MenuProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { BsThreeDots, BsThreeDotsVertical } from "react-icons/bs";
import IconMenu from "./IconMenu";

interface ThreeDotMenuProps extends MenuButtonProps, PropsWithChildren {
  menuProps?: Omit<MenuProps, "children">;
  menuFontSize?: MenuListProps["fontSize"];
  ariaLabel?: string;
  inPortal?: boolean;
  size?: string;
}

export function HThreeDotMenu({
  menuProps = {}, inPortal = false, ariaLabel = "Options", menuFontSize, children, ...rest
}: ThreeDotMenuProps) {
  return (
    <IconMenu
      inPortal={inPortal}
      menuProps={menuProps}
      menuFontSize={menuFontSize}
      ariaLabel={ariaLabel}
      icon={BsThreeDots}
      {...rest}
    >
      {children}
    </IconMenu>
  );
}

export function VThreeDotMenu({
  menuProps = {}, inPortal = false, ariaLabel = "Options", menuFontSize, children, ...rest
}: ThreeDotMenuProps) {
  return (
    <IconMenu
      inPortal={inPortal}
      menuProps={menuProps}
      menuFontSize={menuFontSize}
      ariaLabel={ariaLabel}
      icon={BsThreeDotsVertical}
      {...rest}
    >
      {children}
    </IconMenu>
  );
}
